import { useState } from "react";
import { api, extractError } from "@/lib/api";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { toast } from "sonner";

export function ReguaExecutarDialog({ open, onOpenChange, onDone }) {
  const [busy, setBusy] = useState(false);

  const executar = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/whatsapp/regua/executar");
      toast.success(`${data.disparos_gerados} mensagem(ns) em envio · ~${data.estimativa_minutos} min (intervalo anti-bloqueio)`);
      onOpenChange(false);
      onDone();
    } catch (e) {
      toast.error(extractError(e) || "Falha ao executar a régua");
    } finally {
      setBusy(false);
    }
  };

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent className="rounded-sm">
        <AlertDialogHeader>
          <AlertDialogTitle>Enviar as cobranças de hoje agora?</AlertDialogTitle>
          <AlertDialogDescription>
            As mensagens serão enviadas de verdade aos lojistas (WhatsApp e e-mail), uma a cada 10–15 segundos.
            Use "Simular envios de hoje" antes para conferir o conteúdo.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid="regua-executar-cancelar">Cancelar</AlertDialogCancel>
          <AlertDialogAction data-testid="regua-executar-confirmar" disabled={busy} onClick={(e) => { e.preventDefault(); executar(); }}
            className="bg-foreground text-background hover:bg-foreground/90">
            {busy ? "Iniciando..." : "Enviar agora"}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
